import { render, staticRenderFns } from "./Fenghuang.vue?vue&type=template&id=69fecda9&scoped=true&"
import script from "./Fenghuang.vue?vue&type=script&lang=js&"
export * from "./Fenghuang.vue?vue&type=script&lang=js&"
import style0 from "./Fenghuang.vue?vue&type=style&index=0&id=69fecda9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fecda9",
  null
  
)

export default component.exports